var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VendorsListLayout',{attrs:{"moduleName":"benefits"},on:{"publisher-click":_vm.trackPublisherClick,"publisher-display":_vm.trackPublisherDisplay}})
}
var staticRenderFns = []

export { render, staticRenderFns }